import Bundle from './Bundle.enhanced'
import './bundle.styles.css'

export default Bundle
